import { render, staticRenderFns } from "./backgroundSplash.vue?vue&type=template&id=48388710&scoped=true&"
import script from "./backgroundSplash.vue?vue&type=script&lang=js&"
export * from "./backgroundSplash.vue?vue&type=script&lang=js&"
import style0 from "./backgroundSplash.vue?vue&type=style&index=0&id=48388710&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48388710",
  null
  
)

export default component.exports